import styled, { css } from 'styled-components';

const descriptionStyle = css`
  max-width: 560px;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 32px;
  font-size: 14px;
  line-height: 21px;
`;

export const Title = styled.h2`
  color: ${(props) => props.theme.colors['primary-60']};
  font-weight: 600;
  margin-bottom: 24px;
  font-size: 26px;
  line-height: 30px;
`;

export const Content = styled.div`
  text-align: center;
  margin-top: 60px;
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
`;

export const AboveTitle = styled.p`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 32px;
`;

export const SubTitle = styled.p`
  ${descriptionStyle}
`;

export const Description = styled.div`
  p {
    ${descriptionStyle}
  }
`;

export const Img = styled.img`
  margin-bottom: 32px;
  width: 100%;
  max-width: 560px;
`;
